// 案例详解组件使用
import * as types from '@/store/mutations-types.js'

const state = {
  caseExplainDialog: false // 案例详解弹窗
}

const action = {}

const mutations = {
  [types.CASE_EXPLAIN_DIALOG] (state, caseExplainDialog) {
    state.caseExplainDialog = caseExplainDialog
  }
}

export default {
  state,
  action,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/help/case-explain.js